module.exports = __webpack_public_path__ + "static/media/tshirt.6cbf0b17.svg";